import { render, staticRenderFns } from "./ModuleLinks.vue?vue&type=template&id=431f16cc"
import script from "./ModuleLinks.vue?vue&type=script&lang=js"
export * from "./ModuleLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports